import { useAuth } from '@/src/context/AuthContext';
import { useTheme } from '@/src/context/ThemeContext';
import { useTranslation } from '@/src/i18n';
import { LoginScreen } from '@/src/presentation/screens/LoginScreen';
import { useRouter } from 'expo-router';
import { useState } from 'react';
import { platformAlert } from '@/src/core/utils/platformAlert';

export default function LoginContainer() {
  const router = useRouter();
  const { colors } = useTheme();
  const { t } = useTranslation();
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email.trim() || !password.trim()) {
      platformAlert(t('common.error'), t('alerts.enterEmailPassword'));
      return;
    }

    try {
      setLoading(true);
      const { error } = await signIn(email.trim(), password);

      if (error) {
        const isRateLimitError = (err: any) =>
          err?.status === 429 || /after \d+ seconds/i.test(err?.message ?? '');
        let msg: string;
        if (error.name === 'AuthRetryableFetchError') {
          msg = t('errors.networkError');
        } else if (isRateLimitError(error)) {
          msg = t('errors.rateLimitAuth');
        } else {
          msg = error.message || t('auth.invalidCredentials');
        }
        platformAlert(t('auth.loginFailed'), msg);
      }
    } catch (error: any) {
      platformAlert(t('common.error'), error.message || t('errors.somethingWentWrong'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginScreen
      email={email}
      setEmail={setEmail}
      password={password}
      setPassword={setPassword}
      loading={loading}
      handleLogin={handleLogin}
      navigateToRegister={() => router.push('/auth/register')}
      navigateToForgotPassword={() => router.push('/auth/forgot-password')}
      colors={colors}
    />
  );
}
